var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpressLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.5 -1.5 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wordpress"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    stroke: "#21759b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M42.1875 22.5c0 10.873125 -8.814375 19.6875 -19.6875 19.6875S2.8125 33.373125 2.8125 22.5 11.626875 2.8125 22.5 2.8125c2.1487499999999997 0 4.216875 0.3440625 6.1528125 0.9806250000000001",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#21759b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M37.573125000000005 21.515625c-1.9218749999999998 4.835625 -5.896875 14.38875 -8.758125 18.2109375L18.500625000000003 11.425312499999999M37.573125000000005 21.515625l0.39749999999999996 -1.0078125m-0.39749999999999996 1.0078125c0.178125 -0.3403125 0.309375 -0.676875 0.39749999999999996 -1.0078125m0 0c0.46125 -1.1775 0.7312500000000001 -1.89375 0.7312500000000001 -1.89375l-0.009375 0.001875 0.008437499999999999 -0.0046875c1.681875 -3.7368750000000004 2.563125 -13.3378125 -3.5887499999999997 -13.3378125 -3.841875 0 -4.921875 4.921875 -1.8459375 7.3828125 2.1 1.68 5.596875 4.49625 4.704375 7.8515625Zm-15.13875 3.511875s-1.0153125 2.8115625 -3.5596875000000003 7.9106250000000005m0 0a166.846875 166.846875 0 0 1 -4.1653125 7.796250000000001c-4.2684375 -8.76 -8.2190625 -21.69375 -9.612187500000001 -26.4553125M19.272187499999998 31.931250000000002 12.346875 11.426250000000001m0 0H6.5034375m5.844375 0h1.4803125m4.6725 0h7.3828125m-7.3828125 0h-1.1578125000000001m10.078125 0h-1.5374999999999999m0 0 7.3828125 19.6875",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressLogoBlue);
export default __webpack_public_path__ + "static/media/wordpress-logo-blue.b3e9782883e024554b25601f575743d2.svg";
export { ForwardRef as ReactComponent };